import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Badge } from '../ui/badge';
import { Textarea } from '../ui/textarea';
import { Play } from 'lucide-react';

export const TestFlowDialog = ({
  open,
  onOpenChange,
  flow,
  testMessage,
  setTestMessage,
  testResult,
  onTest
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Probar Flujo: {flow?.name}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Mensaje de prueba</Label>
            <Textarea
              value={testMessage}
              onChange={(e) => setTestMessage(e.target.value)}
              placeholder="Escriba un mensaje para probar si activa el flujo..."
              rows={3}
            />
          </div>
          <Button onClick={onTest} className="w-full">
            <Play className="h-4 w-4 mr-2" />
            Probar Trigger
          </Button>
          
          {testResult && (
            <div className="border rounded-lg p-4 space-y-2">
              <div className="flex items-center gap-2">
                {testResult.would_trigger ? (
                  <Badge className="bg-green-500">✅ Activaría el flujo</Badge>
                ) : (
                  <Badge variant="secondary">❌ No activaría el flujo</Badge>
                )}
              </div>
              
              {testResult.matches?.length > 0 && (
                <div>
                  <p className="text-sm font-medium">Coincidencias:</p>
                  <div className="flex flex-wrap gap-1 mt-1">
                    {testResult.matches.map((m, i) => (
                      <Badge key={i} variant="outline">{m.type}: {m.value}</Badge>
                    ))}
                  </div>
                </div>
              )}
              
              {Object.keys(testResult.extracted_slots || {}).length > 0 && (
                <div>
                  <p className="text-sm font-medium">Slots extraídos:</p>
                  <pre className="text-xs bg-gray-100 p-2 rounded mt-1">
                    {JSON.stringify(testResult.extracted_slots, null, 2)}
                  </pre>
                </div>
              )}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TestFlowDialog;
